'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  badge: {
    backgroundColor: _colors2.default.theme,
    borderRadius: '12px',
    boxSizing: 'border-box',
    boxShadow: _styles2.default.depthShadows[0],
    color: _colors2.default.white,
    display: 'block',
    fontSize: '12px',
    fontWeight: 'inherit',
    height: '20px',
    lineHeight: '14px',
    padding: '3px',
    textAlign: 'center',
    minWidth: '20px',
    transition: 'background .3s ease-in-out'
  },
  inverted: {
    color: _colors2.default.theme,
    backgroundColor: _colors2.default.white
  }
};
module.exports = exports.default;